<template>
    <section style="height:100%">
        <el-row class="container not-print">
            <el-col :span="24" class="header" style="position: fixed; z-index:999">
                <el-col :span="5">
                    <span style="margin-left:20px;font-size:20px;">用电安全物联网平台</span>
                </el-col>
                <el-col :span="19">
                    <el-row>
                        <!--<el-col :span="2" v-if="me.rname === 'ROLE_PLATFORM' || me.rname === 'ROLE_ADMIN' || me.rname === 'ROLE_DEMO'">-->
                            <!--<router-link to="/dashboard" tag="div" class="menu-item my-tab-item" :class="{'menu-item-actived': $route.path == '/dashboard'}">-->
                                <!--<img src="static/computer.png"/>-->
                                <!--<span class="caption">系统监控</span>-->
                            <!--</router-link>-->
                        <!--</el-col>-->
                        <el-col :span="2" class="mgl30">
                            <router-link to="/" tag="div" class="menu-item my-tab-item" :class="{'menu-item-actived': $route.path == '/'}">
                                <img src="static/volume.png"/>
                                <span class="caption">设备监控</span>
                            </router-link>
                        </el-col>
                        <el-col :span="2" class="mgl30">
                            <router-link to="/event" tag="div" class="menu-item my-tab-item" :class="{'menu-item-actived': $route.path == '/event'}">
                                <img src="static/caution.png"/>
                                <span class="caption">报警事件</span>
                            </router-link>
                        </el-col>
                        <el-col :span="2" class="mgl30">
                            <router-link to="/his" tag="div" class="menu-item my-tab-item" :class="{'menu-item-actived': $route.path == '/his'}">
                                <img src="static/clipboard.png"/>
                                <span class="caption">历史数据</span>
                            </router-link>
                        </el-col>
                        <el-col :span="2" class="mgl30">
                            <router-link to="/report" tag="div" class="menu-item my-tab-item" :class="{'menu-item-actived': $route.path.startsWith('/report')}">
                                <img src="static/trends.png"/>
                                <span class="caption">诊断报告</span>
                            </router-link>
                        </el-col>
                        <el-col :span="2" class="mgl30">
                            <router-link to="/energy/active-power" tag="div" class="menu-item my-tab-item" :class="{'menu-item-actived': $route.path.startsWith('/energy')}">
                                <img src="static/recycle.png"/>
                                <span class="caption">能效管理</span>
                            </router-link>
                        </el-col>
                        <el-col :span="2" class="mgl30">
                            <router-link to="/notice" tag="div" class="menu-item my-tab-item" :class="{'menu-item-actived': $route.path == '/notice'}">
                                <img src="static/mail.png"/>
                                <span class="caption">系统通知</span>
                                <div style="position:relative;top:-70px;left:16px;"><el-badge v-show="unreadCount > 0" :value="unreadCount" class="item"></el-badge></div>
                            </router-link>
                        </el-col>
                        <el-col :span="2" class="mgl30" v-if="me.rname === 'ROLE_ADMIN'">
                            <router-link to="/settings/company" tag="div" class="menu-item my-tab-item" :class="{'menu-item-actived': $route.path.startsWith('/settings')}">
                                <img src="static/profle.png"/>
                                <span class="caption">系统设置</span>
                            </router-link>
                        </el-col>
                        <el-col :span="2" class="mgl30">
                            <div class="menu-item my-tab-item" @click="logout">
                                <img src="static/exit.png"/>
                                <span class="caption">登出系统</span>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
            </el-col>
        </el-row>
        <el-row style="padding-top:60px;height: 100%;box-sizing: border-box;">
            <el-col :span="24" class="content-wrapper">
                <transition name="fade" mode="out-in">
                    <router-view></router-view>
                </transition>
            </el-col>
        </el-row>
    </section>

</template>
<style>
    .my-tab-item {
        width: 120px !important;
    }
    .mgl30 {
        margin-left: 30px;
    }
</style>
<script>

    import {getUnread} from '../api/api';
    import Bus from '../bus.js';


    export default{
        data() {
            return {
                me: JSON.parse(sessionStorage.getItem('user')),
                unreadCount: 0
            }
        },
        methods: {
            getUnreadCount() {
                getUnread().then((res) => {
                    this.unreadCount = res.data;
                    //NProgress.done();
                });
            },
            //退出登录
            logout: function () {
                var _this = this;
                this.$confirm('确认退出吗?', '提示', {
                    //type: 'warning'
                }).then(() => {
                    sessionStorage.removeItem('user');
                    _this.$router.push('/login');
                }).catch(() => {

                });
            },
        },
        mounted() {
            Bus.$on('reloadUnreadCount', text => {
                this.getUnreadCount();
            });
            this.getUnreadCount();
        }
    }
</script>



// WEBPACK FOOTER //
// NormalLayout.vue?6a2fb24c